import { Pipe, PipeTransform } from '@angular/core';
import {environment} from "../../../environments/environment";

@Pipe({
  standalone: true,
  name: 'image_placeholder'
})
export class ImagePlaceholderPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(!value){
      return '~/assets/images/PolywinLogo.png';
    }
    return value.startsWith('http') ? value : `${environment.ImgUrl}/${value}`;
  }

  /****************************
   * example useage
   * src="{{agent.agentLogo | adjust_image_path }}"
   ****************************/

}
